module.exports = __webpack_public_path__ + "img/pockets_place.3e904977.png";